export const resizeTextareaToContent = (textarea: HTMLTextAreaElement | null) => {
    if (!textarea) return

    // Reset the previous inline height first so the field can shrink as well
    // as grow when its content or available width changes.
    textarea.style.height = 'auto'
    textarea.style.height = `${textarea.scrollHeight + 2}px`
}
